module.exports = "<div class=\"text-center\">\n    <h3 class=\"mb\">\n        {{ authService.getLoggedUser().first_name }}'s Experience Points\n    </h3>\n    <progressbar value=\"{{ getProgress() }}\"></progressbar>\n\n    <p class=\"text-right\">\n        {{ authService.getLoggedUser().experience }} / {{ maxPoints }} experience points\n        <br />\n        Apply for <a routerLink=\"/contributions\">bonus experience points</a>.\n    </p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/experience-block/experience-block.component.html
// module id = 744
// module chunks = 1